import PlatformTooltip from './platform-tooltip';

export default PlatformTooltip;